import Button from "@web-ui/components/Button";
import Empty from "@web-ui/components/Empty";

/**
 * What a report says before there is anything to show: why, and the one thing to do. Never a
 * chart of zeros.
 */
export function NoData({ title = "No viewing yet", why = "Numbers appear once viewers watch in your apps.", action }: { title?: string; why?: string; action?: { label: string; href: string } }) {
  return (
    <Empty icon="chart" title={title} description={why}
      action={action ? <Button as="a" variant="secondary" size="sm" href={action.href}>{action.label}</Button> : undefined} />
  );
}

/** The backend did not answer: said once, plainly. */
export function ReportFailed() {
  return <Empty icon="warning" title="These numbers did not load" description="Viewing numbers are not available right now. Reload the page to try again." />;
}
